module.exports = __webpack_public_path__ + "static/apple-touch-icon-02323bb1fdfa05c223589e7e98bcbebb.png";